// @flow

import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';
import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';
import AffordableQualificationService from '../../../services/affordableQualificationService';
import useAbortController from '../../../hooks/useAbortController';

const useDownloadAll59AsMutation = ({
  propertyId,
  organizationId,
  options,
  grEffectiveDate,
}: {
  propertyId: string,
  organizationId: string,
  options?: UseMutationOptions<Object, mixed, void, mixed>,
  // Selected gross rent batch. Sent so the merged 59A only contains certs for that
  // effective date instead of every open GRC on the property (ENG-30783).
  grEffectiveDate?: ?string,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(async () => {
    const fileName = `${formatDateDB(new Date())} - Gross Rent 59a Batch.pdf`;

    return new AffordableQualificationService().batchGenerateGrossRent59As(
      organizationId,
      propertyId,
      fileName,
      abortControllerOptions,
      grEffectiveDate,
    );
  }, options);
};

export default useDownloadAll59AsMutation;
